/** The `license` object of an `asset.json` ([contract §11]). */
export interface Licence {
  spdx?: string | null;
  source?: string | null;
  url?: string | null;
  author?: string | null;
}

const SOURCES: Record<string, string> = {
  polyhaven: "Poly Haven",
  ambientcg: "ambientCG",
};

const MARKETPLACES: Record<string, string> = {
  cgtrader: "CGTrader",
  turbosquid: "TurboSquid",
  sketchfab: "Sketchfab",
  fab: "Fab",
};

/** Where an object, a surface or an artwork comes from and under what terms,
 *  as one line a person reads. The licence's identifier is never shown; an
 *  unknown one gives no line. */
export function licenceLine(
  licence: Licence | null | undefined,
): string | null {
  if (!licence) return null;
  const source = licence.source ?? "";
  const author = (licence.author ?? "").trim();
  switch (licence.spdx) {
    case "CC0-1.0":
      return (
        "Free to use (CC0)" +
        (SOURCES[source] ? ` · ${SOURCES[source]}` : "") +
        (author ? ` · ${author}` : "")
      );
    case "LicenseRef-TrueReel":
      return "Made by TrueReel";
    case "LicenseRef-Commercial":
      return "Licensed by TrueReel";
    case "LicenseRef-Own":
      return "Your own";
    case "LicenseRef-Marketplace":
      return MARKETPLACES[source]
        ? `Bought from ${MARKETPLACES[source]}`
        : "Bought from a marketplace";
    case "LicenseRef-Other":
      return "Used under another licence";
    case "LicenseRef-Generated":
      return author ? `Generated for you by ${author}` : "Generated for you";
    default:
      return null;
  }
}
